import { getFeatureFlagService } from '@art-basel/artbasel-lib-platform';

export enum FeatureFlagKeys {
  COPY_ITEM = 'ab_copy_item',
  CURRENCY_CONFIGURATION = 'ab_currency_configuration',
  DIGITAL_PORTFOLIO = 'ab_digital_portfolio',
  ITEM_TRANSFER = 'ab_item_transfer',
  LINK_IN_BIO = 'ab_link_in_bio',
  MARK_AS_SOLD = 'ab_mark_as_sold',
  NEW_DASHBOARD = 'ab_new_dashboard',
  NOTIFICATIONS = 'ab_notifications',
  PAYMENT_SETTINGS = 'ab_payment_settings',
  SUBSCRIPTION = 'ab_subscription',
  TEAM = 'ab_team',
  VIEWING_ROOMS = 'ab_viewing_rooms',
  VIDEO_ARTWORKS = 'ab_video_artworks',
  SECTORS = 'ab_sectors',
  MAGIC_LINK_LOGIN = 'ab_magic_link_login',
  CHUNKED_ART_UPLOAD = 'ab_chunked_art_upload',
}

export const isFeatureEnabled = (key: FeatureFlagKeys): boolean => {
  return getFeatureFlagService().isFeatureEnabled(key);
};

export const isCopyItemEnabled = (): boolean => {
  return isFeatureEnabled(FeatureFlagKeys.COPY_ITEM);
};

export const isDigitalPortfolioEnabled = (): boolean => {
  return false;
};

export const isItemTransferEnabled = (): boolean => {
  return false;
};

export const isNewDashboardEnabled = (): boolean => {
  return isFeatureEnabled(FeatureFlagKeys.NEW_DASHBOARD);
};

export const isPaymentSettingsEnabled = (): boolean => {
  return isFeatureEnabled(FeatureFlagKeys.PAYMENT_SETTINGS);
};

export const isNotificationsEnabled = (): boolean => {
  return isFeatureEnabled(FeatureFlagKeys.NOTIFICATIONS);
};

export const isMarkAsSoldEnabled = (): boolean => {
  return false;
};

export const isTeamEnabled = (): boolean => {
  return isFeatureEnabled(FeatureFlagKeys.TEAM);
};

export const isViewingRoomsEnabled = (): boolean => {
  return isFeatureEnabled(FeatureFlagKeys.VIEWING_ROOMS);
};

export const isLinkInBioEnabled = (): boolean => {
  return false;
};

export const isSubscriptionEnabled = (): boolean => {
  return isFeatureEnabled(FeatureFlagKeys.SUBSCRIPTION);
};

export const isCurrencyConfigurationEnabled = (): boolean => {
  return isFeatureEnabled(FeatureFlagKeys.CURRENCY_CONFIGURATION);
};

export const isVideoArtworkEnabled = (): boolean => {
  return isFeatureEnabled(FeatureFlagKeys.VIDEO_ARTWORKS);
};

export const isSectorsEnabled = (): boolean => {
  return isFeatureEnabled(FeatureFlagKeys.SECTORS);
};

export const isMagicLinkEnabled = (): boolean => {
  return isFeatureEnabled(FeatureFlagKeys.MAGIC_LINK_LOGIN);
}

export const isChunkedUploadEnabled = (): boolean => {
  return isFeatureEnabled(FeatureFlagKeys.CHUNKED_ART_UPLOAD);
}
